import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_2 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ScrollerList/ScrollerItem.vue';
import __unplugin_components_1 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ScrollerList/index.vue';
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/SearchBar.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('Popup', {
    attrs: {
      "position": "right",
      "width": "100%"
    },
    model: {
      value: _vm.currValue,
      callback: function ($$v) {
        _vm.currValue = $$v;
      },
      expression: "currValue"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('view-box', {
    ref: "viewBox",
    attrs: {
      "body-padding-bottom": 0
    }
  }, [_c(__unplugin_components_0, {
    attrs: {
      "placeholder": i18n.tc("530"),
      "height": 5
    },
    on: {
      "on-ok": _vm.resetList
    },
    model: {
      value: _vm.keyword,
      callback: function ($$v) {
        _vm.keyword = $$v;
      },
      expression: "keyword"
    }
  }), _c(__unplugin_components_1, {
    ref: "workerList",
    attrs: {
      "is-px": "",
      "show-image": "",
      "circle-image": "",
      "size": _vm.size,
      "check": _vm.check,
      "height": _vm.scrollerHight,
      "total": _vm.list.length
    },
    on: {
      "on-check-ok": _vm.onCheckOk,
      "on-pulldown-loading": _vm.onPulldownLoading,
      "on-pullup-loading": _vm.onPullupLoading
    }
  }, _vm._l(_vm.list, function (item, index) {
    return _c(__unplugin_components_2, {
      key: item.index,
      attrs: {
        "img-url": item.avatar,
        "value": item.id,
        "name": item.name
      },
      nativeOn: {
        "click": function ($event) {
          return _vm.onRadioOk(item);
        }
      }
    }, [_c('div', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _c('div', {
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_vm._v(i18n.tc("531") + _vm._s(item.mobile))])]);
  }), 1)], 1)], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };